import { BaseModel, attr, belongsTo, hasMany } from "../../lib/itn-ui-kit/data";

export default class ActionableItem extends BaseModel {
  static urlPath = "actionable_items";

  @belongsTo("case") onCase;
  @attr("json") actingUser;
  @attr("json") assignedRole;
  @belongsTo("lawfirm") onFirm;
  @attr("boolean") canEdit;
  @attr("boolean") callAssociated;
  @attr("string") relativeDueDate;
  @attr("string") clockState;
  @attr("string") createdAt;
  @attr("string") updatedAt;
  @attr("string") actionDetail;
  @attr("string") dueDate;
  @attr("string") status;
  @attr("string") actionType;
  @attr("string") actionTypeLabel;
  @attr("number") formCount;
  @attr("string") formUrl;
  @attr("string") completedAt;
  @attr("string") updatedBy;
  @attr("string") priority;
  @attr("datetime") priorityDate;
  @attr("array") relatedValidations;
  @belongsTo("client") createdBy;
  @belongsTo("client") completedBy;
  @belongsTo("provider") onProvider;
  @hasMany("question-and-answer") formAnswers;
}
